import { useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { mathpidLogAPICall } from "../../../../redux/logData";
import useAnswer from "../../../../hooks/answeringQuestions/useAnswer";
import useAmplitude from "../../../../hooks/useAmplitude";
import { setQuestionData } from "../../../../redux/amplitude";
import { appsflyer, appsflyerEventName } from "../../../../utils/appsflyer";

const Logger = (props) => {

  const isUnmount = useRef(false);
  const answer = useRef();
  const completeCode = useRef();

  const params = useParams();
  const { setAmplitudeLog } = useAmplitude();

  const answeringQuestions = useSelector(state => state.answeringQuestions);
  const questionData = useSelector(state => state.amplitudeLogData.question_data);


  const dispatch = useDispatch();
  const setLog = payload => { dispatch(mathpidLogAPICall(payload)) };

  const { convertAnswer } = useAnswer();

  useEffect(() => {
    return () => {
      isUnmount.current = true;
    };
  }, []);

  useEffect(() => {
    const data = answeringQuestions?.data
    // 첫 문제일때
    if (data && data?.estQstNowNo === 0) {
      console.log(`***** 문제 푸는 페이지 진입: ${answeringQuestions.learningType}/${answeringQuestions.stageCode} - ${data.stgNm}`);
      // learningEntryType
      setLog({
        verbId: TYPE.LOG.VERB.INITIALIZED,
        objectId: TYPE.LOG.OBJECT.ASSESSMENT,
        idName: 'stgCd',
        idValue: params.stageCode,
        contentInfo: {
          entryPoint: answeringQuestions?.learningEntryType === TYPE.LEARNING_ENTRY.OCR ? 'ep_001' : 'ep_000'
        }
      });

      setAmplitudeLog({
        eventName: {
          name: '학습 시작',
          event: {
            "소스화면": '',
            "학습유형": '',
            "커리큘럼그룹": data.thmaNm,
            "커리큘럼명": data.stepNm,
            "소주제이름": data.stgNm,
            "소주제코드": data.stgCd,
          }
        },
        isHackleSend: true,
      });
      
      appsflyer({
        eventName: appsflyerEventName.learning_start,
        eventParams: {
          af_class: params?.learningType,
          af_content_type: data.stgNm,
          af_content_id: data.stgCd
        }
      })
    } else if (data && data?.estQstNowNo > 0) {
    }

    dispatch(setQuestionData(data));
  }, [answeringQuestions.data]);

  useEffect(() => {
    // 한 문제마다 완료 시
    if (answeringQuestions.answeringCount === 0 || !questionData?.stgCd ) return;

    switch (true) {
      case !isUnmount.current:
      case !!(isUnmount.current && completeCode.current):
        setLog({
          objectId: TYPE.LOG.OBJECT.QUESTION,
          idName: 'qstCd',
          idValue: answeringQuestions.data.qstCd,
          verbId: TYPE.LOG.VERB.ANSWERED,
          contentInfo: {
            answer: answer.current,
            success: answeringQuestions.answer.filter(v => v?.indexOf('\\phantom') === -1).length === 0
              ? 'none'
              : answeringQuestions?.isAnswer
          }
        });
        break;
    }

    setAmplitudeLog({
      eventName: {
        name: '학습문항풀이 완료',
        event: {
          "학습유형": '',
          "커리큘럼그룹": questionData?.thmaNm,
          "커리큘럼명": questionData?.stepNm,
          "소주제이름": questionData?.stgNm,
          "소주제코드": questionData?.stgCd,
          "문항코드": questionData?.qstCd,
          "정답 여부": answeringQuestions?.isAnswer ? 'Y' : 'N',
          "문항노출순서": `${answeringQuestions?.answeringCount - 1}/${questionData?.totQstCt}`
        }
      }
    });
    
  }, [answeringQuestions.answeringCount])
  
  useEffect(() => {
    if (answeringQuestions.data.qstCd) {
      const data = {
        objectId: TYPE.LOG.OBJECT.QUESTION,
        idName: 'qstCd',
        idValue: answeringQuestions.data.qstCd
      };
      setLog({ ...data, verbId: TYPE.LOG.VERB.OPENED });
    }
  }, [answeringQuestions.data.qstCd]);

  useEffect(() => {
    answer.current = convertAnswer(answeringQuestions.answer);
  }, [answeringQuestions.answer]);

  useEffect(() => {
    // 마지막 문제 완료 시 
    completeCode.current = answeringQuestions.resultData.prgsCd;
    const data = answeringQuestions?.data;
    if (answeringQuestions.answeringCount === 0) return;
    if (answeringQuestions.resultData.prgsCd) {
      setLog({
        verbId: TYPE.LOG.VERB.COMPLETED,
        objectId: TYPE.LOG.OBJECT.ASSESSMENT,
        idName: 'stgCd',
        idValue: params.stageCode,
        contentInfo: {
          entryPoint: answeringQuestions?.learningEntryType === TYPE.LEARNING_ENTRY.OCR ? 'ep_001' : 'ep_000'
        }
      });
    }

    setAmplitudeLog({
      eventName: {
        name: '학습문항풀이 완료',
        event: {
          "학습유형": '',
          "커리큘럼그룹": data?.thmaNm,
          "커리큘럼명": data?.stepNm,
          "소주제이름": data?.stgNm,
          "소주제코드": data?.stgCd,
          "문항코드": data?.qstCd,
          "정답 여부": answeringQuestions.isAnswer ? 'Y' : 'N',
          "문항노출순서": `${answeringQuestions.answeringCount}/${answeringQuestions.answeringCount}`
        }
      }
    });

  }, [answeringQuestions.resultData.prgsCd]);

  useEffect(() => {
    return () => {
      if (!completeCode.current) {
        setLog({
          verbId: TYPE.LOG.VERB.TERMINATED,
          objectId: TYPE.LOG.OBJECT.ASSESSMENT,
          idName: 'stgCd',
          idValue: params.stageCode,
          contentInfo: {
            entryPoint: 'ep_001'
          }
        });
      }
    };
  }, []);

  return props.children || null;

};

export default Logger;
